<template>
  <apexchart :width="width" :type="type" :series="series" :options="options" />
</template>

<script>
export default {
  name: 'CommonChart',
  props: {
    type: {
      type: String,
      default: 'donut'
    },
    seriesProp: {
      type: Array,
      default: () => []
    },
    optionsProp: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: undefined
    }
  },
  watch: {
    seriesProp() {
      this.updateChartParams();
    },
    optionsProp() {
      this.updateChartParams();
    }
  },
  mounted() {
    this.updateChartParams();
  },
  data: () => ({
    options: {
      labels: [],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true
            }
          }
        }
      },
      tooltip: {
        enabled: false
      }
    },
    series: []
  }),
  methods: {
    updateChartParams() {
      this.series = this.seriesProp;
      this.options = {
        ...this.options,
        ...this.optionsProp
      };
    }
  }
};
</script>
